let language = {
    STORE_SETTING_ISSUE_PAGE_LOADING_TITLE: "页面加载异常",
    STORE_SETTING_ISSUE_PAGE_LOADING_CONTENT: "加载此页时发生问题。请刷新页面再试一次。如果问题仍然存在，请随时通过{{supportmail}}联系我们的支持团队。",
    "A109B263542786": "店铺信息无效。",
    STORE_SETTING_URL_INVALID_PARAM_TITLE: "无效的URL",
    STORE_SETTING_URL_PARAM_MISSING_CONTENT: "存储设置URL无效。请返回到上一页，再试一次。如果您需要进一步的帮助，请随时通过{{supportmail}}联系我们的支持团队。",
    // 参数缺失
    "A109B263548911": "尝试打开店铺信息设置时，缺少“{{missingField}}”。",
    CUSTOMER_ORDER_LIST_ORDER_FOUND: "查询到的待拼单项",
    CUSTOMER_ORDER_LIST_ORDER_SELECTED: "已选择的待拼单项",
    CUSTOMER_ORDER_LIST_COMBINE_SELECTED: "合并已选项",
    CUSTOMER_ORDER_LIST_COMBINE_ALL: "合并所有项",
    CUSTOMER_ORDER_LIST_PRODUCT: "产品",
    CUSTOMER_ORDER_LIST_ORDER_NO: "序号",
    CUSTOMER_ORDER_LIST_DATE: "日期",
    CUSTOMER_ORDER_LIST_COUNTRY: "目的地",
    CUSTOMER_ORDER_LIST_PRICE: "价格",
    CUSTOMER_ORDER_LIST_END: "末尾",
    BULKABLE_ITEM_LIST_TITLE: "合并订单摘要",
    BULKABLE_ITEM_LIST_TOTAL: "总价",
    BULKABLE_ITEM_LIST_CHECKOUT: "结算",

    // tips
    CUSTOMER_ORDER_LIST_PRODUCT_VALIABLE: "产品並不存在，請重新建立該產品",
    CUSTOMER_ORDER_LIST_COMBINE_ORDER_EMPTY: "待拼单列表项为空",
    BULKABLE_ITEM_LIST_COMBINE_ORDER_EMPTY: "临时拼单列表项为空"
};

export { language }